import React from 'react'
import PropTypes from 'prop-types'
import styles from './List.scss'
import { classNames, variationName } from 'utils/styles'

export default class List extends React.PureComponent {
  static Item = ({ children }) => <li className={styles.Item}>{children}</li>
  static propTypes = {
    type: PropTypes.string,
    children: PropTypes.any,
  }

  render() {
    const { type = 'bullet', children } = this.props

    const classes = classNames(styles.List, type && styles[variationName('type', type)])

    const ListElement = type === 'bullet' ? 'ul' : 'ol'
    return <ListElement className={classes}>{children}</ListElement>
  }
}



// WEBPACK FOOTER //
// ./src/components/List/index.js